"use client";

import { useGetAgents } from "@/hooks/main-hook";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { socialMediaPlatforms } from "@/data/main-data";

export default function Agents() {
  const t = useTranslations("Home");

  const { data, isLoading } = useGetAgents({ page: 1, limit: 3 });

  const agents = data?.agents || [];

  return (
    <div>
      <div className="sm:container px-4 md:px-0 lg:w-[50%] mx-auto py-5">
        <div className="pb-5">
          <h2 className="text-2xl font-bold text-main text-center">
            {t("meet")}
          </h2>
          <p className="max-w-4xl mx-auto text-dark mt-3 text-center">
            {t("agentDes")}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {isLoading ? (
            <>
              <AgentCardSkeleton />
              <AgentCardSkeleton />
              <AgentCardSkeleton />
            </>
          ) : (
            agents?.map((agent: any) => (
              <div key={agent.id} className="bg-white shadow px-4 py-2">
                <Link
                  href={`/agents/${agent.slug}`}
                  className="flex justify-center"
                >
                  <Image
                    src={agent?.user?.photo || "/user.webp"}
                    alt={agent?.user?.username || "agent image"}
                    width={400}
                    height={300}
                    priority
                    className="rounded-b-full"
                  />
                </Link>
                <h3 className="text-lg font-semibold mt-3 text-center text-dark capitalize">
                  {agent?.user?.username}
                </h3>

                <ul className="flex items-center justify-center gap-4 py-4">
                  {agent.social_links.map((social: any, index: number) => {
                    const socialIcons = socialMediaPlatforms.find(
                      (e) => e.value === social.platform
                    );

                    return (
                      <li
                        key={index}
                        className="border  rounded-full border-main hover:bg-main hover:text-white duration-500"
                      >
                        <Link
                          href={social.url}
                          target="_blank"
                          rel="noreferrer"
                          className="p-2 block"
                        >
                          {socialIcons && <socialIcons.icon size={20} />}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

const AgentCardSkeleton = () => {
  return (
    <div className="bg-white shadow px-4 py-2 animate-pulse">
      <div className="flex justify-center">
        <div className="rounded-b-full bg-gray-300 w-[400px] h-[300px]"></div>
      </div>

      <div className="mt-3 h-5 w-32 bg-gray-300 mx-auto rounded"></div>

      <ul className="flex items-center justify-center gap-4 py-4">
        {[1, 2, 3].map((i) => (
          <li
            key={i}
            className="border rounded-full border-gray-300 p-2 bg-gray-200 w-10 h-10"
          ></li>
        ))}
      </ul>
    </div>
  );
};
